var React = require('react');

function Tous (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3","y":"3","width":"8","height":"8","rx":"1.5","key":0}),React.createElement("rect",{"x":"13","y":"3","width":"8","height":"8","rx":"1.5","key":1}),React.createElement("rect",{"x":"3","y":"13","width":"8","height":"8","rx":"1.5","key":2}),React.createElement("rect",{"x":"13","y":"13","width":"8","height":"8","rx":"1.5","key":3})]);
}

Tous.defaultProps = {"viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = Tous;

Tous.default = Tous;
